export function invoiceDate(value: string | null | undefined): string {
  if (!value) return '—';
  const date = value.slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(date) ? `${date.slice(5, 7)}/${date.slice(8, 10)}/${date.slice(0, 4)}` : value;
}

export function invoiceMoney(value: string | number): string {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : String(value);
}

export function invoiceStatus(value: string): string {
  return value.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (letter) => letter.toUpperCase());
}

/** Selected discount ids of a preview, in the server's (applied) order. */
export function selectedDiscountIds(preview: { appliedDiscounts: Array<{ discountId: string }> }): string[] {
  return preview.appliedDiscounts.map((discount) => discount.discountId);
}

/**
 * The discount ids to request after the user removes or re-adds one chip:
 * the preview's current selection with `discountId` toggled. No money math:
 * the server re-prices the invoice with the new list.
 */
export function toggleDiscountId(preview: { appliedDiscounts: Array<{ discountId: string }> }, discountId: string): string[] {
  const current = selectedDiscountIds(preview);
  return current.includes(discountId) ? current.filter((id) => id !== discountId) : [...current, discountId];
}

/** Chip label for a discount: "10%" or "$25.00 off". */
export function discountRuleLabel(discount: { type: string; value: string }): string {
  if (discount.type === 'PERCENTAGE') return `${Number(discount.value)}%`;
  return `${invoiceMoney(discount.value)} off`;
}

/** Label of the badge on late-fee invoices (list, detail, AR aging, statement). */
export const FINANCE_CHARGE_BADGE_LABEL = 'Finance charge';

/**
 * True for a late-fee invoice created by the finance-charge run. A missing
 * invoiceType (older responses) means STANDARD.
 */
export function isFinanceChargeInvoice(invoice: { invoiceType?: string | null } | null | undefined): boolean {
  return invoice?.invoiceType === 'FINANCE_CHARGE';
}
